import {
    LineChartOutlined,
    CarOutlined,
    UserOutlined,
    DatabaseOutlined,
    ApartmentOutlined,
    CreditCardOutlined,
    TeamOutlined,
    RiseOutlined,
    AuditOutlined,
    BarChartOutlined,
    SafetyCertificateOutlined,
    DeliveredProcedureOutlined,
    DollarCircleOutlined,
} from '@ant-design/icons';
import React from 'react';
export const LOCAL_STORAGE_PREFIX = 'vato';
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;

export const IN_APP_HOME_PAGE_PATH = '/menu';

export const SIDE_BAR_MENU_ITEMS = [
    {
        title: 'Quản lý công ty',
        path: '/company',
        icon: <ApartmentOutlined />,
        isMenu: true,
        roles: [1],
        superCompany: true,
        breadcrumbPath: ['Quản lý công ty'],
    },
    {
        title: 'Phân quyền',
        path: '/permission',
        icon: <AuditOutlined />,
        isMenu: true,
        roles: [1],
        superCompany: true,
        breadcrumbPath: ['Phân quyền'],
        subMenus: [
            {
                title: 'Quản lý chức năng',
                path: '/feature',
                breadcrumbPath: ['Quản lý chức năng'],
            },
            {
                title: 'Quản lý chức vụ',
                path: '/role',
                breadcrumbPath: ['Quản chức vụ'],
            },
            {
                title: 'Phân quyền nhân viên',
                path: '/employee-role',
                breadcrumbPath: ['Phân quyền nhân viên'],
            },
        ],
    },
    {
        title: 'Quản lý nhân viên',
        path: '/employee',
        icon: <UserOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        breadcrumbPath: ['Quản lý nhân viên'],
    },
    {
        title: 'Cấu hình hóa đơn',
        path: '/setting-bill',
        icon: <UserOutlined />,
        isMenu: true,
        roles: [1],
        breadcrumbPath: ['Cấu hình hóa đơn'],
        superCompany: true,
    },
    {
        title: 'Quản lý phương tiện',
        path: '/vehicle',
        icon: <CarOutlined />,
        isMenu: true,
        // superCompany: true,
        roles: [1, 2],
        breadcrumbPath: ['Quản lý phương tiện'],
        subMenus: [
            {
                title: 'Quản lý phương tiện',
                path: '/list',
                breadcrumbPath: ['Quản lý phương tiện'],
            },
            {
                title: 'Bản đồ xe',
                path: '/map',
                breadcrumbPath: ['Bản đồ xe'],
            },
        ],
    },
    {
        title: 'Quản lý tuyến',
        path: '/route',
        icon: <DatabaseOutlined />,
        isMenu: true,
        roles: [1, 2],
        superCompany: false,
        breadcrumbPath: ['Quản lý tuyến'],
        subMenus: [
            {
                title: 'Cài đặt tuyến',
                path: '/list',
                breadcrumbPath: ['Cài đặt tuyến'],
            },

            {
                title: 'Cài đặt trạm/bến',
                path: '/stop',
                breadcrumbPath: ['Cài đặt trạm/bến'],
            },
        ],
    },
    {
        title: 'Điều tài',
        path: '/routes',
        icon: <DatabaseOutlined />,
        isMenu: true,
        roles: [1, 2, 9, 10],
        superCompany: false,
        breadcrumbPath: ['Điều tài'],
        subMenus: [
            {
                title: 'Phân công',
                path: '/trip',
                breadcrumbPath: ['Phân công'],
            },

            {
                title: 'Cài đặt bảng tài',
                path: '/driver-setting',
                breadcrumbPath: ['Cài đặt bảng tài'],
            },
            // {
            //     title: 'Phân công (Clone)',
            //     path: '/trip-clone',
            //     breadcrumbPath: ['Phân công (Clone)'],
            // },
        ],
    },

    {
        title: 'Khách hàng',
        path: '/customer',
        icon: <TeamOutlined />,
        isMenu: true,
        roles: [1, 2, 8, 9],
        superCompany: false,
        breadcrumbPath: ['Khách hàng'],
        subMenus: [
            {
                title: 'Tra cứu',
                path: '/search',
                breadcrumbPath: ['Tra cứu'],
            },
            {
                title: 'Thẻ đi xe buýt',
                path: '/ticket-bus',
                breadcrumbPath: ['Thẻ đi xe buýt'],
            },
        ],
    },
    {
        title: 'Vé tháng',
        path: '/monthly-ticket',
        icon: <CreditCardOutlined />,
        isMenu: true,
        superCompany: false,
        roles: [1, 2, 8, 9],
        breadcrumbPath: ['Vé tháng'],
        subMenus: [
            {
                title: 'Đơn mở thẻ',
                path: '/registration-list',
                breadcrumbPath: ['Đơn mở thẻ'],
            },
            {
                title: 'Đơn gia hạn',
                path: '/extend-list',
                breadcrumbPath: ['Đơn gia hạn'],
            },
            {
                title: 'Đơn cấp phôi thẻ',
                path: '/change-card-list',
                breadcrumbPath: ['Đơn cấp phôi thẻ'],
            },
            {
                roles: [1, 2],
                title: 'Cài đặt',
                path: '/setting',
                breadcrumbPath: ['Cài đặt'],
            },
        ],
    },
    {
        title: 'Thống kê',
        path: '/report',
        icon: <LineChartOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        breadcrumbPath: ['Thống kê'],
        subMenus: [
            {
                title: 'Báo cáo doanh thu theo ngày',
                path: '/revenue-date',
                breadcrumbPath: ['Báo cáo doanh thu theo ngày'],
            },
            {
                title: 'Báo cáo tuyến',
                path: '/revenue-route',
                breadcrumbPath: ['Báo cáo tuyến'],
            },
            {
                title: 'Báo cáo chi tiết',
                path: '/revenue-detail',
                breadcrumbPath: ['Báo cáo chi tiết'],
            },
            {
                title: 'Báo cáo doanh thu sản lượng hàng ngày',
                path: '/yield-and-revenue',
                breadcrumbPath: ['Báo cáo doanh thu sản lượng hàng ngày'],
            },
            {
                title: 'Lịch sử mua vé',
                path: '/ticket-purchase-history',
                breadcrumbPath: ['Lịch sử mua vé'],
            },
            {
                title: 'Giao dịch đồng bộ trễ',
                path: '/ticket-sync-history',
                breadcrumbPath: ['Giao dịch đồng bộ trễ'],
            },
            {
                superCompany: true,
                title: 'Báo cáo lịch sử mua vé theo tháng',
                path: '/report-ticket-history',
                breadcrumbPath: ['Báo cáo lịch sử mua vé theo tháng'],
            },
            {
                title: 'Lịch sử giao dịch',
                path: '/top-up-history',
                breadcrumbPath: ['Lịch sử giao dịch'],
            },
            {
                title: 'Thống kê theo tiếp viên',
                path: '/staff-statistics',
                breadcrumbPath: ['Thống kê theo tiếp viên'],
            },
            {
                title: 'Thống kê theo giờ tài',
                path: '/driver-statistics',
                breadcrumbPath: ['Thống kê theo giờ tài'],
            },
            {
                title: 'Chi tiết chuyến đi',
                path: '/trip-statistics',
                breadcrumbPath: ['Chi tiết chuyến đi'],
            },
            {
                title: 'Thống kê loại vé không doanh thu theo chuyến',
                path: '/trips-no-revenue',
                breadcrumbPath: ['Thống kê loại vé không doanh thu theo chuyến'],
            },
            {
                title: 'Thống kê vé tập',
                path: '/trip-set-ticket',
                breadcrumbPath: ['Thống kê vé tập'],
            },

            {
                title: 'Đối soát giao dịch Online',
                path: '/online-transaction-reconciliation',
                breadcrumbPath: ['Đối soát giao dịch Online'],
            },
            {
                title: 'Đối soát giao dịch VNPAY',
                path: '/online-transaction-vnpay',
                breadcrumbPath: ['Đối soát giao dịch VNPAY'],
            },

            {
                title: 'Đối soát GOLAB',
                path: '/online-transaction-golab',
                breadcrumbPath: ['Đối soát GOLAB'],
            },
            {
                title: 'Xuất dữ liệu báo cáo',
                path: '/export-report-data',
                breadcrumbPath: ['Xuất dữ liệu báo cáo'],
            },
        ],
    },
    {
        title: 'Bảng kê',
        path: '/statement',
        icon: <BarChartOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        breadcrumbPath: ['Bảng kê'],
        subMenus: [
            {
                title: 'Bảng kê cấp thẻ',
                path: '/subscription-card-statistics',
                breadcrumbPath: ['Bảng kê cấp thẻ'],
            },
            {
                title: 'Bảng kê nộp tiền nhân viên',
                path: '/staff-payment-statistics',
                breadcrumbPath: ['Bảng kê nộp tiền nhân viên'],
            },
            {
                title: 'Bảng kê nộp tiền tổng hợp',
                path: '/aggregate-payment-statistics',
                breadcrumbPath: ['Bảng kê nộp tiền tổng hợp'],
            },
            {
                title: 'Bảng kê vé tháng',
                path: '/monthly-ticket-report',
                breadcrumbPath: ['Bảng kê vé tháng'],
            },
            {
                title: 'Bảng kê thẻ đi xe buýt NFC',
                path: '/bus-nfc-report',
                breadcrumbPath: ['Bảng kê thẻ đi xe buýt NFC'],
            },
        ],
    },
    {
        title: 'Quản trị',
        path: '/governance',
        icon: <RiseOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        breadcrumbPath: ['Quản trị'],
        subMenus: [
            {
                title: 'Tăng trưởng',
                path: '/growth',
                breadcrumbPath: ['Tăng trưởng'],
            },
            {
                title: 'Hiệu suất khai thác trạm',
                path: '/bus-stop-performance',
                breadcrumbPath: ['Hiệu suất khai thác trạm'],
            },
            {
                title: 'Báo cáo doanh thu theo xe',
                path: '/vehicle-report',
                breadcrumbPath: ['Báo cáo doanh thu theo xe'],
            },
            {
                title: 'Quản lý chất lượng',
                path: '/redirect-crm',
                breadcrumbPath: ['Quản lý chất lượng'],
            },
        ],
    },
    {
        title: 'Tracking',
        path: '/tracking',
        icon: <RiseOutlined />,
        isMenu: false,
        roles: [1],
        breadcrumbPath: ['Tracking'],
        subMenus: [
            {
                title: 'Tracking vé xe buýt',
                path: '/sold-ticket',
                breadcrumbPath: ['Tracking vé xe buýt'],
            },
        ],
    },
    {
        title: 'Quản lý thu tiền',
        path: '/transport-orders',
        icon: <DollarCircleOutlined />,
        isMenu: true,
        roles: [1, 2, 9, 10],
        superCompany: false,
        breadcrumbPath: ['Quản lý thu tiền'],
        subMenus: [
            {
                roles: [1, 2, 9],
                title: 'Bảng kê chi tiết thu tiền',
                path: '/detail-statement-of-reciept',
                breadcrumbPath: ['Bảng kê chi tiết thu tiền'],
            },
            {
                roles: [1, 2, 9],
                title: 'Bảng kê tổng hợp thu tiền',
                path: '/summary-statement-of-reciept',
                breadcrumbPath: ['Bảng kê tổng hợp thu tiền'],
            },
            {
                roles: [1, 2, 9],
                title: 'Thu ngân nộp ngân hàng',
                path: '/cashier-deposit-order',
                breadcrumbPath: ['Thu ngân nộp ngân hàng'],
            },
            {
                roles: [1, 2, 9],
                title: 'Kế toán xem thống kê lệnh - tiền',
                path: '/order-statistic-money',
                breadcrumbPath: ['Kế toán xem thống kê lệnh - tiền'],
            },
            {
                roles: [1, 2, 9],
                title: 'Lệnh vận chuyển',
                path: '/shipping-order',
                breadcrumbPath: ['Lệnh vận chuyển'],
            },
            {
                roles: [1, 2, 9, 10],
                title: 'Lệnh vận chuyển điện tử',
                path: '/transport-order-elec',
                breadcrumbPath: ['Lệnh vận chuyển điện tử'],
            },
            {
                roles: [1, 2, 9, 10],
                title: 'Thống kê Kiểm tra Lệnh',
                path: '/report-transport-order-elec',
                breadcrumbPath: ['Thống kê Kiểm tra Lệnh'],
            },
            {
                roles: [1],
                title: 'Thay đổi dữ liệu LVC',
                path: '/edit-transport-order-elec',
                breadcrumbPath: ['Thay đổi dữ liệu LVC'],
            },
        ],
    },
    {
        title: 'Điều hành',
        path: '/executive',
        icon: <SafetyCertificateOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        superCompany: true,
        breadcrumbPath: ['Điều hành'],
        subMenus: [
            {
                title: 'Kiểm soát mất chuyến',
                path: '/lost-flight-trip',
                breadcrumbPath: ['Kiểm soát mất chuyến'],
            },
            {
                title: 'Kiểm soát tài chuyến',
                path: '/trip-driver',
                breadcrumbPath: ['Kiểm soát tài chuyến'],
            },
        ],
    },
    {
        title: 'Quảng  cáo trên vé buýt',
        path: '/promotion',
        icon: <DeliveredProcedureOutlined />,
        isMenu: true,
        roles: [1, 2, 9],
        superCompany: true,
        breadcrumbPath: ['Quảng  cáo trên vé buýt'],
    },
    {
        title: 'Kế hoạch kinh doanh',
        path: '/business-plan',
        icon: <DeliveredProcedureOutlined />,
        isMenu: true,
        roles: [1, 2],
        superCompany: true,
        breadcrumbPath: ['Kế hoạch kinh doanh'],
    },
    // {
    //     title: 'Bán vé OTA',
    //     path: '/ota-ticket-sales',
    //     icon: <DeliveredProcedureOutlined />,
    //     isMenu: true,
    //     roles: [1, 2, 9],
    //     superCompany: false,
    //     breadcrumbPath: ['Bán vé OTA'],
    //     subMenus: [
    //         {
    //             title: 'Cài đặt gói vé lượt',
    //             path: '/package-ticket-setting',
    //             breadcrumbPath: ['Cài đặt gói vé lượt'],
    //         },
    //         {
    //             title: 'Bảng kê gói vé OTA',
    //             path: '/ota-admin',
    //             breadcrumbPath: ['Bảng kê gói vé OTA'],
    //         },
    //     ],
    // },
    {
        title: 'Module Trạm sạc',
        path: '/charging-station',
        icon: <DatabaseOutlined />,
        isMenu: true,
        roles: [1, 2],
        superCompany: false,
        breadcrumbPath: ['Module Trạm sạc'],
        subMenus: [
            {
                title: 'Cài đặt Trạm sạc',
                path: '/setting',
                breadcrumbPath: ['Cài đặt Trạm sạc'],
            },
            {
                title: 'Sạc xe',
                path: '/schedules',
                breadcrumbPath: ['Sạc xe'],
            },
        ],
    },
];

export const ROLES = {
    1: { name: 'ROLE_ADMIN', value: 1, label: 'Super Admin', shortLabel: 'SA' },
    2: { name: 'ROLE_COMPANY_ADMIN', value: 2, label: 'Admin', shortLabel: 'Admin' },
    // 3:{ name:'ROLE_OPERATOR', value:3, label:'Nhân viên vận hành', shortLabel:'NV-VH' },
    // 4:{ name:'ROLE_TICKET_OFFICER', value:4, label:'Nhân viên bán vé',shortLabel:'NV-BV' },
    5: { name: 'ROLE_CONDUCTOR', value: 5, label: 'Tiếp viên', shortLabel: 'TV' },
    6: { name: 'ROLE_DRIVER', value: 6, label: 'Tài xế', shortLabel: 'TX' },
    // 7:{ name:'ROLE_ACCOUNTANT', value:7, label:'Kế toán' ,shortLabel:'KT' },
    8: { name: 'ROLE_SALE', value: 8, label: 'Nhân viên kinh doanh', shortLabel: 'NV-KD' },
    9: { name: 'ROLE_CONTROLLER', value: 9, label: 'Kiểm soát', shortLabel: 'KS' },
    10: { name: 'OPERATOR_ONLINE', value: 10, label: 'Điều hành trực tuyến', shortLabel: 'ĐHTT' },
};

export const PAYMENT_TYPE = [
    {
        value: 'CASH',
        label: 'Tiền mặt',
    },
    {
        value: 'CARD',
        label: 'Thẻ Ngân hàng',
    },
    {
        value: 'QR',
        label: 'QR code-FUTAPAY',
    },
    {
        value: 'WALLET',
        label: 'Ví',
    },
    {
        value: 'SUBSCRIPTION',
        label: 'Thẻ tháng',
    },
    {
        value: 'UNKNOWN',
        label: 'Không xác định',
    },
];

export const TYPE_TRANSPORT_ORDER_ELEC = {
    NONE: 'NONE',
    SENT: 'SENT',
    SIGNED: 'SIGNED',
    FAILED: 'FAILED',
    PROCESSING: 'PROCESSING',
    BEGIN_DAY_SIGNED: 'BEGIN_DAY_SIGNED',
};

export const statusMap = {
    resend: [TYPE_TRANSPORT_ORDER_ELEC.FAILED, TYPE_TRANSPORT_ORDER_ELEC.SENT, TYPE_TRANSPORT_ORDER_ELEC.SIGNED],
    resign: [TYPE_TRANSPORT_ORDER_ELEC.NONE, TYPE_TRANSPORT_ORDER_ELEC.SENT],
};
